import { Navigate, Route, Routes } from 'react-router';
import { CoachLayout, PublicShell, StudentLayout } from './layouts.tsx';
import { useAuth } from './lib/auth.tsx';
import { Spinner } from './lib/ui.tsx';

// public
import Login from './pages/Login.tsx';
import RegisterCoach from './pages/RegisterCoach.tsx';
import JoinInvite from './pages/JoinInvite.tsx';
import Directory from './pages/public/Directory.tsx';
import CoachPublicProfile from './pages/public/CoachPublicProfile.tsx';
import TemplateGallery from './pages/public/TemplateGallery.tsx';

// coach
import CoachDashboard from './pages/coach/Dashboard.tsx';
import Onboarding from './pages/coach/Onboarding.tsx';
import StudentDetail from './pages/coach/StudentDetail.tsx';
import Exercises from './pages/coach/Exercises.tsx';
import Templates from './pages/coach/Templates.tsx';
import ReviewQueue from './pages/coach/ReviewQueue.tsx';
import TakeReview from './pages/coach/TakeReview.tsx';
import TakeCompare from './pages/coach/TakeCompare.tsx';
import CoachMessages from './pages/coach/Messages.tsx';
import CoachCalendar from './pages/coach/Calendar.tsx';
import Billing from './pages/coach/Billing.tsx';
import StudioPage from './pages/coach/Studio.tsx';
import MarketplaceSettings from './pages/coach/Marketplace.tsx';
import CoachSettings from './pages/coach/Settings.tsx';
import CoachLiveLesson from './pages/coach/LiveLesson.tsx';

// student
import Today from './pages/student/Today.tsx';
import Player from './pages/student/Player.tsx';
import RangeTestPage from './pages/student/RangeTest.tsx';
import Warmup from './pages/student/Warmup.tsx';
import Progress from './pages/student/Progress.tsx';
import Takes from './pages/student/Takes.tsx';
import TakeDetail from './pages/student/TakeDetail.tsx';
import StudentMessages from './pages/student/Messages.tsx';
import Lessons from './pages/student/Lessons.tsx';
import StudentSettings from './pages/student/Settings.tsx';
import StudentLiveLesson from './pages/student/LiveLesson.tsx';

function Home() {
  const { me, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!me) return <Navigate to="/coaches" replace />;
  return <Navigate to={me.role === 'coach' ? '/coach' : '/app'} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<RegisterCoach />} />
      <Route path="/join/:token" element={<JoinInvite />} />

      <Route element={<PublicShell />}>
        <Route path="/coaches" element={<Directory />} />
        <Route path="/coaches/:id" element={<CoachPublicProfile />} />
        <Route path="/gallery" element={<TemplateGallery />} />
      </Route>

      <Route element={<CoachLayout />}>
        <Route path="/coach" element={<CoachDashboard />} />
        <Route path="/coach/onboarding" element={<Onboarding />} />
        <Route path="/coach/students/:id" element={<StudentDetail />} />
        <Route path="/coach/exercises" element={<Exercises />} />
        <Route path="/coach/templates" element={<Templates />} />
        <Route path="/coach/review" element={<ReviewQueue />} />
        <Route path="/coach/review/:takeId" element={<TakeReview />} />
        <Route path="/coach/compare" element={<TakeCompare />} />
        <Route path="/coach/messages" element={<CoachMessages />} />
        <Route path="/coach/messages/:studentId" element={<CoachMessages />} />
        <Route path="/coach/calendar" element={<CoachCalendar />} />
        <Route path="/coach/billing" element={<Billing />} />
        <Route path="/coach/studio" element={<StudioPage />} />
        <Route path="/coach/marketplace" element={<MarketplaceSettings />} />
        <Route path="/coach/settings" element={<CoachSettings />} />
        <Route path="/coach/live/:lessonId" element={<CoachLiveLesson />} />
      </Route>

      <Route element={<StudentLayout />}>
        <Route path="/app" element={<Today />} />
        <Route path="/app/warmup" element={<Warmup />} />
        <Route path="/app/range-test" element={<RangeTestPage />} />
        <Route path="/app/progress" element={<Progress />} />
        <Route path="/app/takes" element={<Takes />} />
        <Route path="/app/takes/:id" element={<TakeDetail />} />
        <Route path="/app/messages" element={<StudentMessages />} />
        <Route path="/app/lessons" element={<Lessons />} />
        <Route path="/app/settings" element={<StudentSettings />} />
      </Route>

      {/* the player and live room run full-screen outside the tab shell */}
      <Route path="/app/player" element={<Player />} />
      <Route path="/app/live/:lessonId" element={<StudentLiveLesson />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
